<template>
  <v-layout wrap>
    <v-flex sm12 xs12 md12>
      <v-spacer />
      <div class="text-lg-right">
        <v-btn block outline color="tertiary" @click="dialog = true"
          ><v-icon left>add</v-icon>Criar Tarefa</v-btn
        >
      </div>
    </v-flex>
    <v-flex sm12 xs12 md12>
      <div class="text-lg-center" v-if="tasks.length <= 0">
        Crie tickets e tarefas para a equipe atuar.
        <!-- Você pode até fazer uma @mention a um colega de equipe se precisar. . -->
      </div>
      <div v-else>
        <v-card
          color="white"
          dark
          v-for="(item, index) in tasks"
          :key="index"
          class="mb-3"
          @click="
            setSelected(index);
            editDialog = true;
          "
        >
          <v-card-text :class="item.status === 'closed' ? 'green' : 'pb-1'">
            <v-layout align-center>
              <v-icon
                class="mr-2"
                :color="item.status === 'closed' ? 'white' : 'grey'"
                >{{ item.status | taskStatusIcon }}</v-icon
              >
              <span
                :class="
                  item.status === 'closed'
                    ? 'subheading white--text'
                    : 'text--lighten-2 subheading black--text'
                "
                >{{
                  item.departament_id.charAt(0).toUpperCase() +
                  item.departament_id.slice(1)
                }}</span
              >
              <v-spacer></v-spacer>
              <span
                :class="
                  item.status === 'closed'
                    ? 'subheading pl-2 white--text'
                    : 'subheading pl-2 grey--text'
                "
                >{{ item.status | taskStatus }}</span
              >
            </v-layout>
          </v-card-text>
          <v-card-text class="white text--primary pb-0 pt-3">
            <p v-html="item.content"></p>
          </v-card-text>
          <v-divider></v-divider>
          <v-layout column>
            <v-card-actions class="pt-0 pb-0">
              <v-btn dark icon>
                <v-icon color="teal">flag</v-icon>
              </v-btn>
              <span class="teal--text caption pr-2"
                >Prioridade {{ item.priority }}h</span
              >
              <v-btn dark icon>
                <v-icon :color="item.responsible_name != null ? 'teal' : 'grey'"
                  >person</v-icon
                >
              </v-btn>
              <span v-if="item.responsible_name" class="teal--text caption">{{
                item.responsible_name
              }}</span>
              <span v-else class="grey--text caption">Sem responsável</span>
              <v-spacer></v-spacer>
              <span class="text--primary caption"
                >Expira em: {{ item.due | formatarDate }}</span
              >
            </v-card-actions>
          </v-layout>
        </v-card>
      </div>
    </v-flex>
    <v-flex v-if="tasks.length > 0" sm12 xs12 md12 class="text-xs-center">
      <v-btn
        color="primary"
        @click="getMoreTasks"
        :disabled="loading"
        :loading="loading"
        ><v-icon left>expand_more</v-icon>Carregar Mais</v-btn
      >
    </v-flex>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">Tarefa</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    v-if="id"
                    v-model="id"
                    readonly
                    disabled
                    hide-details
                  ></v-text-field>
                  <v-textarea
                    box
                    name="content"
                    v-model="content"
                    value
                    placeholder="Comece a digitar para adicionar uma tarefa..."
                    hint="Mínimo de 30 caracteres"
                    required
                  ></v-textarea>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-select
                    prepend-inner-icon="flag"
                    :items="prioritys"
                    v-model="priority"
                    item-text="text"
                    item-value="value"
                    return-object
                    label="Criticidade*"
                    :hint="priority_hint"
                    required
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-select
                    prepend-inner-icon="supervised_user_circle"
                    :items="departaments"
                    v-model="departament"
                    item-text="text"
                    item-value="value"
                    return-object
                    label="Departamento*"
                    required
                  ></v-select>
                </v-flex>
                <!-- {{agents}} -->
                <v-flex xs12 sm4>
                  <v-select
                    prepend-inner-icon="person"
                    :items="agents"
                    v-model="responsible"
                    item-text="name"
                    item-value="id"
                    return-object
                    label="Consultor*"
                    required
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-dialog
                    ref="dialog"
                    v-model="modal"
                    :return-value.sync="date"
                    persistent
                    lazy
                    full-width
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="date"
                        label="Vencimento"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker dark v-model="date" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="modal = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        flat
                        color="primary"
                        @click="$refs.dialog.save(date)"
                        >OK</v-btn
                      >
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="dialog = false"
              >Fechar</v-btn
            >
            <v-btn color="blue darken-1" flat @click="createTask">Salvar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout row justify-center>
      <v-dialog v-model="editDialog" persistent max-width="900px">
        <v-card>
          <v-card-title>
            <span class="headline">Tarefa</span>
          </v-card-title>
          <v-card-text v-if="taskDetail">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    v-if="id"
                    v-model="id"
                    readonly
                    disabled
                    hide-details
                  ></v-text-field>
                  <v-textarea
                    v-model="taskDetail.content"
                    label="Descrição"
                    readonly
                  ></v-textarea>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                    prepend-inner-icon="flag"
                    v-model="taskDetail.priority"
                    label="Criticidade"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                    prepend-inner-icon="supervised_user_circle"
                    v-model="taskDetail.departament_id"
                    label="Departamento"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                    prepend-inner-icon="person"
                    v-model="taskDetail.responsible_name"
                    label="Consultor"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                    prepend-inner-icon="event"
                    :value="taskDetail.due | formatarDate"
                    label="Vence em"
                    readonly
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm12 md12>
                  <span>Comentários</span>
                  <v-list three-line>
                    <template v-for="(item, index) in taskDetail.comments">
                      <v-list-tile :key="item.id" avatar ripple>
                        <v-list-tile-content>
                          <v-list-tile-title>{{
                            item.created_by_name
                          }}</v-list-tile-title>
                          <span
                            v-html="item.content"
                            class="grey--text body-1"
                          ></span>
                        </v-list-tile-content>

                        <v-list-tile-action>
                          <v-list-tile-action-text>{{
                            item.created_at | formatarDate
                          }}</v-list-tile-action-text>
                        </v-list-tile-action>
                      </v-list-tile>
                      <v-divider
                        v-if="index + 1 < taskDetail.comments.length"
                        :key="index"
                      ></v-divider>
                    </template>
                  </v-list>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <span>Adicionar Comentário</span>
                  <v-text-field
                    v-if="id"
                    v-model="id"
                    readonly
                    disabled
                    hide-details
                  ></v-text-field>
                  <v-textarea
                    box
                    name="content"
                    v-model="commentContent"
                    value
                    placeholder="Comece a digitar para adicionar um comentário..."
                    hint="Mínimo de 15 caracteres"
                    required
                  ></v-textarea>
                  <v-btn color="blue darken-1" @click="createComment()"
                    >Adicionar</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="editDialog = false"
              >Fechar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-layout>
</template>
<script>
import { mapGetters, mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      loading: false,
      dialog: false,
      editDialog: false,
      taskDetail: {},
      commentContent: "",
      content: "",
      id: null,
      priority: {},
      date: "",
      modal: false,
      selected: [2],
      prioritys: [
        { text: "Prioridade 1", value: "60" },
        { text: "Prioridade 2", value: "36" },
        { text: "Prioridade 3", value: "8" },
        { text: "Prioridade 4", value: "1" },
      ],
      departament: {},
      departaments: [
        { text: "Faturamento", value: "faturamento" },
        { text: "Tecnologia", value: "tecnologia" },
        { text: "Vendas", value: "vendas" },
        { text: "Atendimento", value: "atendimento" },
        // {text: 'Administrativo', value:"1"}
      ],
      responsible: {},
    };
  },
  computed: {
    ...mapState("cs", ["userCS", "task"]),
    ...mapGetters("cs", ["tasks", "agents"]),
    ...mapState(["user"]),
    //   ...mapState('cs', ['activeTaskTab', 'loadingTaskCS'])
    priority_hint() {
      if (this.priority.value)
        return "Finaliza em " + this.priority.value + " horas";
      else return "";
    },
  },
  watch: {
    task(val) {
      // console.log('val d', val)
      if (val) {
        this.taskDetail = val;
      }
    },
  },
  mounted() {
    //   if(this.activeBilling === 1 && this.billings.length <= 0) {
    //     this.getBillingByConsumerUnit(this.consumerUnit.id)
    //   }
    this.getAgents({ categories: ["admin", "vendas", "cs"] });
    this.getTasksByParam({ id: this.userCS.id, type: "user" });
    // console.log('mounted comments', this.tasks[0].comments[0])
    // console.log('mounted content', this.tasks[0].content)
  },
  methods: {
    ...mapActions("cs", [
      "getTasksByParam",
      "addTask",
      "addCommentInTask",
      "getAgents",
      "setSelectedTask",
    ]),
    async getMoreTasks() {
      this.loading = true;
      await this.getTasksByParam({
        id: this.userCS.id,
        type: "user",
        loaded: this.tasks,
      });
      this.loading = false;
    },
    toggle(index) {
      const i = this.selected.indexOf(index);

      if (i > -1) {
        this.selected.splice(i, 1);
      } else {
        this.selected.push(index);
      }
    },
    async createTask() {
      // console.log("content: ", this.content)
      // console.log("user id: ", this.user.id)
      // console.log("user name: ", this.user.name)
      // console.log("departament: ", this.departament.value)
      // console.log("date: ", this.date)
      // console.log("responsible id: ", this.responsible.id)
      // console.log("responsible name: ", this.responsible.name)
      // console.log("userCS: ", this.userCS.id)
      // console.log("priority: ", this.priority.value)
      await this.addTask({
        content: this.content,
        created_by_id: this.user.id,
        created_by_name: this.user.name,
        departament_id: this.departament.value,
        due: this.date,
        responsible_id: this.responsible.id,
        responsible_name: this.responsible.name,
        user_id: this.userCS.id,
        priority: this.priority.value,
      });
      this.content = "";
    },
    async createComment() {
      // console.log("taskId: ", this.taskDetail.id)
      // console.log("description: ", this.commentContent)
      // console.log("c id: ", this.user.id)
      // console.log("c name: ", this.user.name)
      await this.addCommentInTask({
        task: this.taskDetail,
        content: this.commentContent,
        created_by_id: this.user.id,
        created_by_name: this.user.name,
      });
      this.commentContent = "";
    },
    async setSelected(index) {
      // console.log("set selected", index, this.tasks[index])
      await this.setSelectedTask({ task: this.tasks[index] });
    },
  },
  filters: {
    taskStatus(value) {
      if (!value) return "?";
      else if (value === "closed") return "Resolvido";
      else if (value === "waiting_customer") return "Aguardando Cliente";
      else if (value === "in_attendance") return "Em Atendimento";
      else return "Aberto";
    },
    taskStatusIcon(value) {
      if (!value) return "error";
      else if (value === "closed") return "check_circle_outline";
      else if (value === "waiting_customer") return "hourglass_empty";
      else if (value === "in_attendance") return "forum";
      else return "schedule";
    },
    formatCommentNumber(value) {
      return value <= 0
        ? ""
        : value === 1
          ? "1 comentário"
          : value + " comentários";
    },
  },
};
</script>
